import React from 'react';
import { useNavigate } from 'react-router-dom';

const Card = ({ children, style = {} }) => (
  <div style={{ background: '#ffffff', border: '1px solid #E5E9F0', borderRadius: '1rem', padding: '1.75rem', boxShadow: '0 1px 4px rgba(0,0,0,0.04)', ...style }}>
    {children}
  </div>
);

const Row = ({ icon, label, children }) => (
  <div style={{ display: 'flex', gap: '0.875rem', alignItems: 'flex-start', marginBottom: '1rem' }}>
    <div style={{ flexShrink: 0, width: '36px', height: '36px', borderRadius: '0.5rem', background: '#EFF6FF', color: '#1A6FD6', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '0.9rem' }}>{icon}</div>
    <div>
      <p style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 700, color: '#9CA3AF', marginBottom: '0.2rem' }}>{label}</p>
      <div style={{ color: '#0D1F3C', fontSize: '0.9375rem', lineHeight: 1.55 }}>{children}</div>
    </div>
  </div>
);

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: '#FFFBEB', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>

      {/* Top Bar */}
      <div style={{ background: '#ffffff', borderBottom: '1px solid #E5E9F0', position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'none', border: 'none', cursor: 'pointer', color: '#1A6FD6', fontWeight: 600, fontSize: '0.875rem' }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10 12L6 8l4-4" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Back to Successlane
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#1A6FD6' }}></div>
            <span style={{ fontWeight: 700, color: '#0D1F3C', fontSize: '0.9rem' }}>Successlane</span>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2.5rem 1.5rem' }}>

        {/* Header */}
        <div style={{ marginBottom: '2.5rem' }}>
          <p style={{ fontSize: '0.8125rem', fontWeight: 700, color: '#1A6FD6', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.5rem' }}>Contact Us</p>
          <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#0D1F3C', marginBottom: '0.75rem', lineHeight: 1.2 }}>Talk to us</h1>
          <p style={{ color: '#6B7280', fontSize: '1rem', lineHeight: 1.6 }}>
            Got a question about your order, our service, a refund, or anything else? Reach out using any of the channels below — a real person will get back to you, usually within one business day.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem' }}>

          <Card>
            <h2 style={{ color: '#0D1F3C', fontSize: '1.125rem', fontWeight: 700, marginBottom: '1.25rem' }}>Reach us</h2>

            <Row icon="@" label="Email">
              <a href="mailto:contact@successlane.io" style={{ color: '#1A6FD6', textDecoration: 'none', fontWeight: 600 }}>contact@successlane.io</a>
              <p style={{ color: '#6B7280', fontSize: '0.8125rem', marginTop: '0.2rem', marginBottom: 0 }}>For order support, refund requests, partnerships, and general queries.</p>
            </Row>

            <Row icon="☎" label="Phone">
              <a href="tel:+917259444336" style={{ color: '#1A6FD6', textDecoration: 'none', fontWeight: 600 }}>+91 72594 44336</a>
              <p style={{ color: '#6B7280', fontSize: '0.8125rem', marginTop: '0.2rem', marginBottom: 0 }}>Available during working hours listed below.</p>
            </Row>

            <Row icon="⌖" label="Registered office">
              Success Lane<br />
              21/22, T2, 3rd Floor,<br />
              Girinagar 2nd Phase,<br />
              Bangalore, Karnataka 560085<br />
              India
            </Row>

            <Row icon="◷" label="Working hours">
              Monday to Saturday · 9:00 AM – 6:00 PM IST<br />
              <span style={{ color: '#6B7280', fontSize: '0.8125rem' }}>Closed on Sundays and Indian public holidays.</span>
            </Row>
          </Card>

          <Card>
            <h2 style={{ color: '#0D1F3C', fontSize: '1.125rem', fontWeight: 700, marginBottom: '0.5rem' }}>Response times</h2>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                ['Order delivery support', 'Within 48 hours during working days'],
                ['Refund / cancellation requests', 'Acknowledged within 1 business day, resolved within 5–7 business days'],
                ['Privacy or grievance queries (DPDP Act 2023)', 'Acknowledged within 2 business days, resolved within 30 days'],
                ['Recruiter applications & partnerships', 'Within 3–5 business days'],
              ].map(([label, val], i) => (
                <li key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', padding: '0.75rem 0', borderBottom: i < 3 ? '1px solid #F1F5F9' : 'none', flexWrap: 'wrap' }}>
                  <span style={{ color: '#0D1F3C', fontWeight: 600, fontSize: '0.875rem' }}>{label}</span>
                  <span style={{ color: '#6B7280', fontSize: '0.875rem' }}>{val}</span>
                </li>
              ))}
            </ul>
          </Card>

          <Card>
            <h2 style={{ color: '#0D1F3C', fontSize: '1.125rem', fontWeight: 700, marginBottom: '0.5rem' }}>About the company</h2>
            <p style={{ color: '#374151', fontSize: '0.9375rem', lineHeight: 1.7, marginBottom: 0 }}>
              Successlane is operated by <strong>Success Lane</strong>, a registered partnership firm based in Bangalore, India. The firm is currently not registered for GST as its annual turnover is below the threshold limit of ₹20 lakhs prescribed under Section 22 of the CGST Act, 2017. All prices displayed on the platform are final and inclusive of any applicable taxes.
            </p>
          </Card>
        </div>

        {/* Footer */}
        <div style={{ borderTop: '1px solid #E5E9F0', paddingTop: '2rem', marginTop: '2.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
          <p style={{ color: '#9CA3AF', fontSize: '0.8125rem' }}>© 2025 Success Lane · Successlane</p>
          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            <button onClick={() => navigate('/about')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1A6FD6', fontSize: '0.8125rem', fontWeight: 500 }}>About</button>
            <button onClick={() => navigate('/terms')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1A6FD6', fontSize: '0.8125rem', fontWeight: 500 }}>Terms</button>
            <button onClick={() => navigate('/privacy')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1A6FD6', fontSize: '0.8125rem', fontWeight: 500 }}>Privacy</button>
            <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6B7280', fontSize: '0.8125rem' }}>Back to Home</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
